import { PAGES_RE } from "@waypoint/contracts";
/**
 * Reads a pages string in the `Citation.pages` grammar ("p.12", "pp.11–13", "pp.12–13, 43") into
 * page ranges. Returns undefined when the string is not in the grammar or a range runs backwards.
 */
export function parsePages(pages) {
    if (!PAGES_RE.test(pages))
        return undefined;
    const body = pages.startsWith("pp.") ? pages.slice(3) : pages.slice(2);
    const ranges = [];
    for (const part of body.split(",")) {
        const [fromText, toText] = part.trim().split("–");
        const from = Number(fromText);
        const to = toText === undefined ? from : Number(toText);
        if (to < from)
            return undefined;
        ranges.push({ from, to });
    }
    return ranges;
}
/** True when every page in `cited` is one of the pages in `guide`. */
export function pagesWithin(cited, guide) {
    const merged = mergeRanges(guide);
    return cited.every((c) => merged.some((g) => g.from <= c.from && c.to <= g.to));
}
/** The ranges sorted and joined where they touch or overlap. */
export function mergeRanges(ranges) {
    const sorted = [...ranges].sort((a, b) => a.from - b.from);
    const merged = [];
    for (const r of sorted) {
        const last = merged[merged.length - 1];
        if (last && r.from <= last.to + 1)
            last.to = Math.max(last.to, r.to);
        else
            merged.push({ ...r });
    }
    return merged;
}
//# sourceMappingURL=pages.js.map